import {
  CheckboxInput,
  CustomCalendar,
  CustomTextArea,
  FormContainer,
  Input,
  SelectFinalForm,
} from "../../components/inputs";
import { Field, Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "../../components/button";
import { FetchCategories } from "../../redux/category";
import { Grid } from "../../components/section";
import { ImageUploadComponent } from "../../components/imageUpload";
import { Text } from "../../components/typography";
import arrayMutators from "final-form-arrays";
import styled from "styled-components";
import { useEffect } from "react";

export const ExperienceForm = (props) => {
  const { onFormSubmit, initialValues, onHandleImageDelete } = props;
  const { categories } = useSelector((state) => state.category);
  const { videos } = useSelector((state) => state.videos);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    dispatch(FetchCategories());
  }, [dispatch]);

  const onSubmit = (values) => {
    const finalValues = {
      ...values,
      categories: values?.categories?.map((item) => {
        return {
          name: item.label,
        };
      }),
      videos: values?.videos?.map((item) => {
        return {
          title: item.label,
          id: item.value,
        };
      }),
    };

    onFormSubmit(finalValues);
  };

  const onCloseandReset = (reset) => {
    reset();

    const direction = location.pathname.split("/").includes("edit")
      ? navigate(-1, { replace: true })
      : navigate("/", { replace: true });
    return direction;
  };

  const newInitialValues = {
    ...initialValues,
    categories: initialValues?.categories?.map((item) => {
      return {
        value: item.id,
        label: item.name,
      };
    }),
    videos: initialValues?.videos?.map((item) => {
      return {
        value: item.id,
        label: item.title,
      };
    }),
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={newInitialValues}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({
        handleSubmit,
        pristine,
        submitting,
        invalid,
        form: {
          reset,
          mutators: { push },
        },
      }) => (
        <form onSubmit={handleSubmit}>
          <Grid col="l15">
            <div>
              <FormContainer>
                <Field
                  name="title"
                  type="text"
                  component={Input}
                  label="Title"
                  placeholder="What is the project title?"
                />
              </FormContainer>
              <FormContainer>
                <Field
                  name="description"
                  label="Describe the experience."
                  component={CustomTextArea}
                />
              </FormContainer>
              <FormContainer>
                <Field
                  name="date"
                  type="text"
                  component={CustomCalendar}
                  label="Date"
                />
              </FormContainer>
              <FormContainer>
                <Field
                  name="categories"
                  type="text"
                  component={SelectFinalForm}
                  label="Categories"
                  isMulti
                  options={categories.map((item) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </FormContainer>
              <Grid>
                <FormContainer>
                  <Field
                    name="location"
                    type="text"
                    component={Input}
                    label="City, State"
                  />
                </FormContainer>
                <FormContainer>
                  <Field
                    name="studio"
                    type="text"
                    component={Input}
                    label="Studio"
                  />
                </FormContainer>
              </Grid>
              <FormContainer>
                <Field name="url" type="text" component={Input} label="Link" />
              </FormContainer>

              <FormContainer>
                <Field
                  name="videos"
                  type="text"
                  component={SelectFinalForm}
                  label="Videos"
                  isMulti
                  options={videos.map((item) => {
                    return {
                      value: item.id,
                      label: item.title,
                    };
                  })}
                />
              </FormContainer>
              <FormContainer>
                <Field
                  label="Featured"
                  name="featured"
                  type="checkbox"
                  component={CheckboxInput}
                />
                {/* <Field
                  label="Upcoming"
                  name="upcoming"
                  type="checkbox"
                  component={CheckboxInput}
                />{" "}
                <Field
                  label="Archive"
                  name="archive"
                  type="checkbox"
                  component={CheckboxInput}
                /> */}
              </FormContainer>
            </div>
            <div>
              <FormContainer>
                <Field name="files">
                  {(props) => {
                    return (
                      <ImageUploadComponent
                        name={props.input.name}
                        files={props.input.value}
                        onupdatefiles={props.input.onChange}
                        onremoveImage={onHandleImageDelete}
                        extraProp={initialValues?.media}
                      />
                    );
                  }}
                </Field>
              </FormContainer>
            </div>
          </Grid>
          <ButtonFlex>
            <Text scale="small" onClick={() => onCloseandReset(reset)}>
              Cancel
            </Text>
            <Button
              type="submit"
              disabled={submitting || pristine || invalid}
              text={submitting ? "Saving..." : "Save"}
            />
          </ButtonFlex>
        </form>
      )}
    </Form>
  );
};

const ButtonFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  a:link,
  p,
  button {
    margin: 0;
    cursor: pointer;
  }
`;
